import React from 'react'
import Banner from '../../../components/Banner'
import Navbar from '../../../components/Navbar'
import ResultsDisclosures from '../../../components/AnnouncementCorporate/ResultsDisclosures'

function ResultsDisclosuresPage() {
    return (
        <div>
            <Banner />
            <Navbar />
            <ResultsDisclosures />
        </div>
    )
}

export default ResultsDisclosuresPage